import React, { useEffect } from 'react';
/**
 * @deprecated - please use IA helper functions to get links via route ID
 * {@link https://checkout.atlassian.net/wiki/spaces/HUBV/pages/7053869259/Dashboard+Config+Structure}
 */
export const NavigationLink = ({ children, onRender, requiredAccountLevels, showLink }) => {
    useEffect(() => {
        onRender(showLink, requiredAccountLevels);
    }, [onRender, requiredAccountLevels, showLink]);
    return showLink ? React.createElement(React.Fragment, null, children) : null;
};
